import styled from "styled-components";

// DESKTOP STYLES - Blue background with centered content
export const DesktopContainer = styled.div`
  width: 100%;
  height: calc(-100px + 100vh);

  position: relative;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 20px;
  overflow: hidden;
`;

export const BackdropImage = styled.img`
  position: absolute;
  width: 100%;
  height: auto;
  top: 0;
  left: -2%;
  z-index: 1;
`;

export const DesktopContent = styled.div`
  width: 100%;
  max-width: 1200px;
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  /* align-items: center; */
  padding: 0 40px;
`;

export const Title = styled.h1`
  color: #142c1f;
  font-size: 22px;
  line-height: 1.5;
  font-weight: 500;
  text-align: center;
  margin-bottom: 40px;
  max-width: 600px;

  @media (max-width: 992px) {
    font-size: 16px;
    text-align: center;
    margin-top: 30px;
    margin-bottom: 0px;
  }
`;

export const CenteredLoader = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 20px 0;
`;

export const PhoneContainer = styled.div`
  position: absolute;
  right: 10%;
  top: 50%;
  transform: translateY(-50%);
`;

export const ReactPlayerContainer = styled.div`
  width: 318px;
  height: 568px;
  border-radius: 15px;
  overflow: hidden;
  box-shadow: 0 8px 15px 8px rgba(224, 224, 224, 0.9);

  & > div {
    width: 100% !important;
    height: 100% !important;
  }

  video {
    object-fit: cover;
  }
`;

// MOBILE STYLES - White background with hand image
export const MobileContainer = styled.div`
  width: 100%;
  min-height: 100vh;
  background-color: white;
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 60px 20px;
  align-items: center;
`;

export const MobileContent = styled.div`
  width: 100%;
  z-index: 2;
  /* margin-bottom: 80px; */
  text-align: center;
`;

export const MobilePhoneContainer = styled.div`
  /* position: absolute;
  right: 0;
  bottom: 0;
  z-index: 1; */
`;

export const PhoneImage = styled.img`
  width: 100%;
  max-width: 318px;
  height: auto;
`;
